import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface AssemblyPrimerHelpProps {
  isGibson: boolean;
  isGoldenGate: boolean;
}

function AssemblyPrimerHelp({isGibson, isGoldenGate}: AssemblyPrimerHelpProps): JSX.Element {
  return (
    <>
      {isGoldenGate && (
        <>
          <p className="u-small-text help-block u-no-spacing-bottom">
            Recognition site in <span className="primer-base-recognition-site">bold</span>. Sticky end in{' '}
            <span className="primer-base-sticky-end">blue</span>. Bases that bind to parent{' '}
            <span className="primer-base-match">highlighted</span>.
          </p>
          <p className="u-small-text help-block u-no-spacing-bottom">
            For point mutations, perform replacements on the sequence map.
          </p>
          <p className="u-small-text help-block u-no-spacing-bottom">
            To insert spacers, click the <span className="glyphicon glyphicon-sound-stereo" /> icon on any
            fragment before creating the assembly.
          </p>
        </>
      )}
      {isGibson && (
        <p className="u-small-text help-block u-no-spacing-bottom">
          For spacers or mismatches, perform edits directly on the sequence map.
        </p>
      )}
    </>
  );
}

export default makeDeprecatedJadeStyleTemplate<AssemblyPrimerHelpProps>(AssemblyPrimerHelp);
